import React, { useState, useEffect, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import AppLoading from "verticales/AppLoading.tsx";
import TableActiveDirectory from "./viewDataTableDA";
import TableUsersConnect from "./viewDataTableUsers";
import TableDiscosEc2 from "../ViewDiscos";
import ViewStandarCpuRam from "./ViewEchartApacheFull";
import fetchData from "verticales/FetchData";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import html2canvas from "html2canvas";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { MyPdfDocument } from "./ReporteArtefactoPDF";

/* Importaciones DatePicker */
import dayjs, { Dayjs } from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const hm = new Map();
const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";

interface Props {
  instanceId: string;
  data: {
    infoEc2?: { rows: any[] },
    dataConectados?: any[],
    dataUsersDA?: any[],
    dataDiscos?: any[],
    dataDisponibilidad?: any,
  };
  dataUsuarios?: any[];
  onAlignmentChange?: (value: string) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BasicTabs(props: Props) {
  const [value, setValue] = useState(0);
  const [selectedValue, setSelectedValue] = useState("diario");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [dataEc2, setDataEc2] = useState({});
  const [dataUsersDA, setDataUserDA] = useState([]);
  const [dataConectados, setDataConectados] = useState([]);
  const [dataDiscos, setDataDiscos] = useState([]);
  const [availability, setAvailability] = useState(100);
  const [indisponibility, setindisponibility] = useState(0);
  const [chartImage, setChartImage] = useState("");
  const [pdfReady, setPdfReady] = useState(false);
  const chartRef = useRef(null);
  const [fechaIni, setFechaIni] = React.useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = React.useState(dayjs(new Date()));

  const captureChart = async () => {
    if (!chartRef.current) return;

    // Esperar a que el gráfico esté completamente renderizado
    await new Promise((resolve) => setTimeout(resolve, 1000));

    try {
      const canvas = await html2canvas(chartRef.current, {
        scale: 2,
        logging: true,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#FFFFFF",
      });
      const image = canvas.toDataURL("image/png");
      setChartImage(image);
      setPdfReady(true);
      return image;
    } catch (error) {
      console.error("Error capturando el gráfico:", error);
      return null;
    }
  };

  const handleDownloadPDF = async () => {
    setPdfReady(false);
    const image = await captureChart();
    if (!image) {
      alert("Error al capturar el gráfico para el PDF...");
      return;
    }
  };

  const fetchForTabs = async (instanceId, period) => {
    setLoading(true);
    const dataUsuDA = props.dataUsuarios;

    const now = Math.floor(Date.now() / 1000);
    const oneDay = 86400;
    const oneWeek = 7 * oneDay;
    const oneMonth = 30 * oneDay;

    let timeRange = now - oneDay;
    var timeRequest = "diario";
    if (period === "semanal") {
      timeRange = now - oneWeek;
      timeRequest = period;
    } else if (period === "mensual") {
      timeRange = now - oneMonth;
      timeRequest = period;
    }

    const fechaActual = new Date();
    const fechaFinal = fechaActual.getTime();

    const params = {
      objeto: instanceId,
      action: "get-data-for-instance",
      timeFilter: timeRange * 1000,
      timeFinal: fechaFinal,
      rango: timeRequest,
    };

    try {
      const result = await fetchData(url, "ec2-disponibilidad", params);
      const userActiveDirectory = props.dataUsuarios;
      const dataDiscosEc2 = result.informacionDiscos.rows;
      let parsedPayload;
      if (result.infoEc2User && result.infoEc2User.rows.length > 0) {
        const payloadData = result.infoEc2User.rows[0].payload[0];

        if (typeof payloadData === "string") {
          try {
            parsedPayload = JSON.parse(payloadData);
          } catch (error) {
            console.error("Error al parsear el JSON:", error);
            parsedPayload = [];
          }
        } else {
          parsedPayload = Array.isArray(payloadData) ? payloadData : [];
        }
      } else {
        parsedPayload = [];
      }

      const userConnect = Array.isArray(parsedPayload)
        ? parsedPayload.filter((payload) =>
            dataUsuDA.some((user) => user.username.toLowerCase() === payload.Username.toLowerCase())
          )
        : [];

      let timeAnterior = 0;
      let totalIndisponibilidad = 0;
      let totalIndisponibilidadGen = 0;
      let sumCpu = 0;
      let sumRam = 0;
      let count = 0;

      for (let objRow of result.infoEc2.rows) {
        let timeAct = parseInt(objRow.t) - 3600 * 5;

        if (timeAnterior > 0) {
          let delta = timeAct - timeAnterior;

          // Indisponibilidad con umbral de 5 minutos (300s)
          if (delta >= 300) {
            totalIndisponibilidad += (delta - 300) / 60;
          }

          // Indisponibilidad con umbral de 1 minuto (60s)
          if (delta >= 60) {
            totalIndisponibilidadGen += (delta - 60) / 60;
          }
        }

        timeAnterior = timeAct;
        sumCpu += parseFloat(objRow.c);
        sumRam += parseFloat(objRow.r);
        count++;
      }

      function formatoHorasMinutos(minutosTotales) {
        const horas = Math.floor(minutosTotales / 60);
        const minutos = Math.round(minutosTotales % 60);
        return `${horas} horas y ${minutos} minutos`;
      }

      // console.log("Indisponibilidad (≥5 min):", totalIndisponibilidad, "min");
      // console.log("Formato:", formatoHorasMinutos(totalIndisponibilidad));

      // console.log("Indisponibilidad (≥1 min):", totalIndisponibilidadGen, "min");
      // console.log("Formato:", formatoHorasMinutos(totalIndisponibilidadGen));

      // console.log("totalIndisponibilidad...", totalIndisponibilidad);

      const timeDisponibleMes = 60 * 24 * 30;
      const disponibilidadTotal = timeDisponibleMes - totalIndisponibilidad;
      const availabilityPercentage = (disponibilidadTotal / timeDisponibleMes) * 100;
      // const availabilityPercentageNo = (totalIndisponibilidad / timeDisponibleMes) * 100;

      // console.log("totalIndisponibilidad %...", availabilityPercentageNo);

      hm.set(period, result);
      const dataInfoEc2 = result.informacionEc2.rows;
      // console.log("DataInfoEc2", result);
      setDataEc2(dataInfoEc2);
      setData(result);
      setDataUserDA(userActiveDirectory);
      setDataConectados(userConnect);
      setDataDiscos(dataDiscosEc2);
      setAvailability(availabilityPercentage);
      setindisponibility(totalIndisponibilidad);

      // Esperar un poco antes de capturar el gráfico
      setTimeout(() => {
        captureChart().catch(console.error);
      }, 1500);
    } catch (error) {
      console.log("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const instanceId = props.instanceId;
    if (instanceId) {
      fetchForTabs(instanceId, selectedValue);
    }
  }, [selectedValue, props.instanceId]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleButtonClick = (value: string) => {
    setSelectedValue(value);
    if (props.onAlignmentChange) {
      props.onAlignmentChange(value);
    }
  };

  const handleButtonClickDisp = async (instanceId) => {
    setLoading(true);
    const dateIni = fechaIni ? fechaIni.toDate().getTime() : null;
    // console.log("Fecha inicial...", dateIni);
    const dateFin = fechaFin ? fechaFin.toDate().getTime() : null;
    // console.log("Fecha Fin...", dateFin);
    const params = {
      objeto: instanceId,
      action: "get-data-for-instance",
      timeFilter: dateIni,
      timeFinal: dateFin,
    };

    try {
      const result = await fetchData(url, "ec2-disponibilidad", params);
      setData(result);
    } catch (err) {
      console.log("Error.....", err);
    } finally {
      setLoading(false);
    }
  };

  const hasInfoEc2Data = data?.infoEc2?.rows?.length > 0;
  const hasInfoEc2UserData = dataConectados?.length > 0;
  const hasInfoEc2UserDataDA = dataUsersDA?.length > 0;
  const hasInfoEc2Discos = dataDiscos?.length > 0;

  const tabs = [];
  if (hasInfoEc2Data) {
    tabs.push({ label: "Metricas Cpu-Ram", content: "Metricas Cpu-Ram" });
  }

  if (hasInfoEc2UserDataDA && hasInfoEc2UserData) {
    tabs.push({ label: "Usuarios Directorio Activo", content: "Usuarios DA" });
    tabs.push({ label: "Usuarios Conectados", content: "Usuarios Conectados" });
  }

  if (hasInfoEc2Discos) {
    tabs.push({ label: "Discos Ec2", content: "Discos Ec2" });
  }

  if (tabs.length === 0) {
    return loading ? (
      <AppLoading titleCustom={"Cargando datos..."} />
    ) : (
      <AppLoading titleCustom={"Cargando datos..."} />
    );
  }

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="dynamic tabs example">
          {tabs.map((tab, index) => (
            <Tab key={"tab1" + index} label={tab.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      {hasInfoEc2Data && value <= 1 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mt: 1,
          }}
        >
          <ButtonGroup aria-label="Basic button group">
            {["diario", "semanal", "mensual"].map((type) => (
              <Button
                key={type}
                sx={{
                  color: selectedValue === type ? "white" : "black !important",
                  backgroundColor: selectedValue === type ? "blue" : "transparent",
                }}
                onClick={() => handleButtonClick(type)}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </Button>
            ))}
          </ButtonGroup>

          {pdfReady ? (
            <PDFDownloadLink
              document={
                <MyPdfDocument
                  activeDirectoryData={dataUsersDA}
                  chartImageDataUrl={chartImage}
                  discosData={dataDiscos}
                  ec2Data={data}
                  disponibilidad={availability}
                />
              }
              fileName={`reporte-${props.instanceId || "artefacto"}.pdf`}
            >
              {({ loading }) => (
                <Button
                  variant="contained"
                  startIcon={<FileDownloadIcon />}
                  sx={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    color: "#000",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  {loading ? "Generando PDF..." : "Descargar PDF"}
                </Button>
              )}
            </PDFDownloadLink>
          ) : (
            <Button
              variant="contained"
              startIcon={<FileDownloadIcon />}
              onClick={handleDownloadPDF}
              sx={{
                fontSize: "12px",
                fontWeight: "normal",
                fontSize: "12px",
                fontWeight: "normal",
                color: "#000",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              Preparar PDF
            </Button>
          )}
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box components={["DatePicker", "DatePicker"]}>
              <DatePicker
                label="Fecha Inicio"
                inputFormat="dd/MM/yyyy hh:mm a"
                onChange={(newValue) => setFechaIni(newValue)}
                value={fechaIni}
              />
              <DatePicker
                label="Fecha Fin"
                inputFormat="dd/MM/yyyy hh:mm a"
                onChange={(newValue) => setFechaFin(newValue)}
                value={fechaFin}
              />
            </Box>
            <Button disableElevation onClick={() => handleButtonClickDisp(props.instanceId)}>
              Buscar Fecha
            </Button>
          </LocalizationProvider> */}
        </Box>
      )}

      <Grid container spacing={0}>
        {tabs.map((tab, index) => (
          <CustomTabPanel key={index} value={value} index={index}>
            {tab.label === "Metricas Cpu-Ram" && value === index ? (
              <div ref={chartRef}>
                {loading ? (
                  <AppLoading titleCustom={"Cargando métricas..."} />
                ) : (
                  <ViewStandarCpuRam data={data} dataDisponibilidad={availability} />
                )}
              </div>
            ) : null}

            {tab.label === "Usuarios Directorio Activo" && value === index ? (
              <TableActiveDirectory data={dataUsersDA} />
            ) : null}

            {tab.label === "Usuarios Conectados" && value === index ? (
              <TableUsersConnect data={dataConectados} />
            ) : null}

            {tab.label === "Discos Ec2" && value === index ? (
              <TableDiscosEc2 data={dataDiscos} />
            ) : null}
          </CustomTabPanel>
        ))}
      </Grid>
    </Box>
  );
}

export default BasicTabs;
